import { useQuery } from "@tanstack/react-query";
import {getCampaignTypes } from "../../service/query/auth";

export const useGetCampaignTypes= () => {
  const campaign_types = useQuery({
    queryKey:["CAMPAIGN_TYPE"],
    queryFn:async()=>  getCampaignTypes(),
    enabled:true,
    staleTime: 0,
  },

);
  return {data:campaign_types?.data?.data,  ...campaign_types,}
};